import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import DetailPage from "../pages/detail/page";
import TopicPage from "../pages/topic/page";
import ArticlePage from "../pages/article/page";
import ActorPage from "../pages/actor/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category", element: <CategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "topic/:id", element: <TopicPage /> },
      { path: "article/:id", element: <ArticlePage /> },
      { path: "actor/:id", element: <ActorPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;